import axios from './index'

export default {
  table(params) {
    return axios.get('/api/v1/user', { params })
  },
  getOneByID(_id) {
    return axios.get(`/api/v1/user/${_id}`)
  },
}